import React from 'react';
import PropTypes from 'prop-types';
import PricingTableRow from './PricingTableRow';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import ConfigurationAPIService from '@lib/api-services/ConfigurationAPIService';

export default class PricingTable extends React.Component {

    _isMounted = false;

    constructor(props) {
        super(props)

        this.state = {
            modulesOptions: [],
            selectedRowId: null,
        };
        scheduleAtDocumentReady(() => {
            this.configurationAPIService = APIServicesRegistry.getService(ConfigurationAPIService);
        })

        this.tableRefs = React.createRef();
        this.pricingTableRowRef = React.createRef();
    }

    componentDidMount() {
        this.editorStepPricing = document.getElementsByClassName(this.props.stepClassName)[0]
    }

    UNSAFE_componentWillMount() {
        this._isMounted = true;
        document.body.addEventListener('click', this.handleClick.bind(this));
    }

    componentWillUnmount() {
        this._isMounted = false;
        document.body.removeEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
        if (!this._isMounted) {
            return;
        }

        if (event.target.id == "add-module") {
            this.setState({selectedRowId: this.props.rows.length})
            return;
        }
        if (this.tableRefs.current && this.tableRefs.current.contains(event.target) == false)
            this.setState({selectedRowId: null})

    }

    static propTypes = {
        columns: PropTypes.array.isRequired,
        rows: PropTypes.array.isRequired,
        onRowColumnChange: PropTypes.func
    }

    static defaultProps = {
        onRowColumnChange: () => {
        }
    }

    getModulesByModuleNumber = (value, callback) => {
        this.configurationAPIService.getModulesByModuleNumber({
            number: value,
            marketSymbol: this.props.marketSymbol,
            productSymbol: this.props.productTypeSymbol
        }).then(response => {
            let res = response.data;
            callback(res);
        })
    }

    getModulesByDescription = (value, callback) => {
        this.configurationAPIService.getModuleNumbersByDescription({
            description: value,
            marketSymbol: this.props.marketSymbol,
            productSymbol: this.props.productTypeSymbol
        }).then(response => {
            let res = response.data;
            callback(res);
        })
    }

    render() {
        const {columns, rows, canAddAndEditRows} = this.props;

        return (
            <div className="responsive-table-container" ref={this.tableRefs}>
                <table className="configuration-editor-pricing-table" ref={this.props.tref}>
                    <thead>
                    <tr>
                        <th>#</th>
                        {columns.map(this.renderHeaderColumn)}
                        {canAddAndEditRows && <th></th>}
                    </tr>
                    </thead>

                    <tbody>
                    {rows.map((row, idx) => (
                        <PricingTableRow
                            canAddAndEditRows={canAddAndEditRows}
                            key={row.id}
                            index={idx}
                            row={{...row}}
                            columns={columns}
                            onChange={(propertySlug, nextValue, focus, onStart, onStop) => this.props.onRowChange(row, propertySlug, nextValue, focus, onStart, onStop)}
                            onCheckboxChange={e => this.props.onRowCheckboxChange(row, e)}
                            getModulesByModuleNumber={this.getModulesByModuleNumber}
                            getModulesByDescription={this.getModulesByDescription}
                            editorStepPricing={this.editorStepPricing}
                            selectedRowId={this.state.selectedRowId}
                            setActiveRow={(i) => this.setState({selectedRowId: i})}
                            loadPricingWithNewComponent={this.props.loadPricingWithNewComponent}
                        />
                    ))}
                    </tbody>
                </table>
            </div>
        )
    }

    renderHeaderColumn = column => {
        if (column.isNumeric) {
            return <th key={column.slug} className="numeric-value">{column.name}</th>
        }

        return <th slug={column.slug} key={column.slug} className={'head-' + column.slug}>{column.name}</th>
    }
}